var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.5L13.6458 15.6646C13.8708 15.8486 14.2031 15.8117 14.3822 15.5828C14.5559 15.3608 14.5203 15.0407 14.3022 14.8622L13.2763 14.0229H19.4771C19.7659 14.0229 20 13.7888 20 13.5C20 13.2112 19.7659 12.9771 19.4771 12.9771L13.2763 12.9771L14.3022 12.1378C14.5203 11.9593 14.5559 11.6392 14.3822 11.4172C14.2031 11.1883 13.8708 11.1514 13.6458 11.3354L11 13.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.5L17.3542 16.3354C17.1292 16.1514 16.7969 16.1883 16.6178 16.4172C16.4441 16.6392 16.4797 16.9593 16.6978 17.1378L17.7237 17.9771H11.5229C11.2341 17.9771 11 18.2112 11 18.5C11 18.7888 11.2341 19.0229 11.5229 19.0229H17.7237L16.6978 19.8622C16.4797 20.0407 16.4441 20.3608 16.6178 20.5828C16.7969 20.8117 17.1292 20.8486 17.3542 20.6646L20 18.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.1524f536165a853f36ebbac6de8796b4.svg";
export { ForwardRef as ReactComponent };